{
  "version": 1,
  "asset_id": "dbe4253e-6437-4311-8bbe-f738c3334fc6",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/dbe4253e-6437-4311-8bbe-f738c3334fc6/palworld-apparel-hoodie.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/dbe4253e-6437-4311-8bbe-f738c3334fc6/palworld-apparel-hoodie.webp",
  "original_filename": "palworld-apparel-hoodie.webp",
  "size": 28046,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:35:54Z"
}
